var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',{attrs:{"bordered":true,"dis-hover":""}},[_c('p',{attrs:{"slot":"title"},slot:"title"},[_vm._t("title")],2),_c('div',{staticClass:"device-status"},[_c('div',{attrs:{"id":"data-left"}}),_c('div',{attrs:{"id":"data-right"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }